import {
    AutocompleteInput,
    DateInput,
    Edit,
    ReferenceInput,
    SimpleForm,
    TextInput,
} from '@/components/admin';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ClipboardList, Wrench } from 'lucide-react';
import { required } from 'ra-core';
import { StatusSelectInput, PrioritySelectInput } from '../documents/shared/StatusSelectInput';

export const DesignRequestEdit = () => {
    return (
        <Edit>
            <SimpleForm className="max-w-4xl mx-auto space-y-6">
                <Card className="w-full shadow-sm">
                    <CardHeader className="pb-3 border-b bg-muted/50">
                        <div className="flex items-center gap-2">
                            <Wrench className="w-5 h-5 text-blue-500" />
                            <CardTitle className="text-lg font-semibold tracking-tight">Edit Design Request</CardTitle>
                        </div>
                    </CardHeader>
                    <CardContent className="pt-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <TextInput source="reference" label="Design Request No." disabled className="w-full font-mono opacity-70" helperText="Auto-generated · Read only" />
                            <TextInput source="title" label="Request Title" validate={required()} className="w-full" />
                            
                            <ReferenceInput source="project_id" reference="projects">
                                <AutocompleteInput label="Linked Project" validate={required()} className="w-full" />
                            </ReferenceInput>

                            <StatusSelectInput
                                source="status"
                                label="Request Status"
                                choices={[
                                    { id: 'draft', name: 'Draft' },
                                    { id: 'requested', name: 'Requested' },
                                    { id: 'in_progress', name: 'In Progress' },
                                    { id: 'completed', name: 'Completed' },
                                    { id: 'cancelled', name: 'Cancelled' },
                                ]}
                                className="w-full"
                            />
                        </div>
                    </CardContent>
                </Card>

                <Card className="w-full shadow-sm">
                    <CardHeader className="pb-3 border-b bg-muted/50">
                        <div className="flex items-center gap-2">
                            <ClipboardList className="w-5 h-5 text-blue-500" />
                            <CardTitle className="text-lg font-semibold tracking-tight">Technical details</CardTitle>
                        </div>
                    </CardHeader>
                    <CardContent className="pt-6 space-y-4">
                        <TextInput source="description" label="Objective & Description" multiline rows={4} className="w-full" />
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                             <DateInput source="due_date" label="Desired Completion Date" className="w-full" />
                             <PrioritySelectInput
                                source="priority"
                                label="Priority"
                                choices={[
                                    { id: 'low', name: 'Low' },
                                    { id: 'medium', name: 'Medium' },
                                    { id: 'high', name: 'High' },
                                    { id: 'urgent', name: 'Urgent' },
                                ]}
                                className="w-full"
                            />
                             <ReferenceInput source="assigned_designer_id" reference="sales">
                                <AutocompleteInput 
                                    label="Assigned Designer" 
                                    className="w-full" 
                                    optionText={(record: any) => record ? `${record.first_name} ${record.last_name}` : ''} 
                                />
                            </ReferenceInput>
                             <DateInput source="completed_at" label="Actual Completion Date" className="w-full" />
                        </div>
                    </CardContent>
                </Card>
            </SimpleForm>
        </Edit>
    );
};
